import React from 'react';

import { NextPageWithLayout } from 'next';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import { CircleImageAndText } from '../components/CircleImageAndText';

import phoneOne from './assets/phoneOne.png';
import phoneThree from './assets/phoneThree.png';
import phoneTwo from './assets/phoneTwo.png';
import { HeaderSection } from '../components/HeaderSection';
import {
  META_FISHING_FISHING_FORECAST_TITLE,
  META_FISHING_FISHING_FORECAST_DESCRIPTION,
  META_FISHING_FISHING_FORECAST_CANONICAL,
} from '../../../constants/metadata';

export const FishingForecastsPage: NextPageWithLayout = () => {
  return (
    <div>
      <MetaTags
        title={META_FISHING_FISHING_FORECAST_TITLE}
        description={META_FISHING_FISHING_FORECAST_DESCRIPTION}
        link={META_FISHING_FISHING_FORECAST_CANONICAL}
      />

      <HeaderSection
        headingText="See today's Fishing Forecast for all your local fishing spots"
        bodyText="Want to know when to go fishing? Fishbrain has you covered. We give you weather trends and
          help you find the perfect window to catch your next personal best. With Fishbrain Pro you
          can see weather forecasts and patterns days in advance - allowing you to pick the best
          day, time, and spot to fish."
      />

      <CircleImageAndText
        imgSrc={phoneOne}
        imgRight
        imgAlt="See forecast conditions by the hour in the Fishbrain app"
        headingText="See local forecast conditions by the hour"
        bodyText="Easily view fishing weather conditions according to time of day and hourly intervals. Want to grab your rod and reel and pop over to the lake over lunch? See the best hours to take your lunch break to increase your odds of catching fish."
      />

      <CircleImageAndText
        imgSrc={phoneTwo}
        imgAlt="Bite time for the species you care about in the Fishbrain app"
        headingText="Get bite times for the species you care about"
        bodyText="Wondering when to fish for bass nearby? Fishbrain’s Bite Time feature gives you the forecast data to plan your optimal fishing trip. Catch the fish you are targeting when they are biting."
      />

      <CircleImageAndText
        imgSrc={phoneThree}
        imgRight
        imgAlt="Hyper-local forecast data in the Fishbrain app"
        headingText="Hyper-local forecast data when and where you need it"
        bodyText="Plan what to pack and which gear to use with hyper-local forecast data for the spot you fish when you fish it."
      />

      <AppDownloadSection />
    </div>
  );
};
